export const CHECK_COPY: Record<string, string> = {
  rows_resolved: 'Review status is green for all companies (fully reviewed or no review needed)',
  carry_forward: 'Marks match the previous day\'s saved CSV when no new price was indicated',
  mark_present: 'A valid mark is present for every company',
};
